import { useDisclosure } from "@heroui/react";
import { useState } from "react";
import { CianSmsModal } from "./CianSmsModal";
import { CianDraftModal } from "./CianDraftModal";
import { api } from "@/api";

export function useCianModal() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [officeId, setOfficeId] = useState<number | null>(null);
  const [isSmsModalOpen, setIsSmsModalOpen] = useState(false);
  const [isDraftModalOpen, setIsDraftModalOpen] = useState(false);

  const openCianModal = (officeId: number) => {
    setOfficeId(officeId);
    onOpen();
    checkSessionAndProceed();
  };

  const checkSessionAndProceed = async () => {
    try {
      const sessionResponse = await api.cian.getSession();

      if (sessionResponse.data) {
        setIsDraftModalOpen(true);
      } else {
        setIsSmsModalOpen(true);
      }
    } catch (error) {
      console.error("Ошибка при проверке сессии Cian:", error);
      setIsSmsModalOpen(true);
    }
  };

  const handleSmsSubmitted = () => {
    setIsSmsModalOpen(false);
    setIsDraftModalOpen(true);
  };

  const handleClose = () => {
    onClose();
    setIsSmsModalOpen(false);
    setIsDraftModalOpen(false);
    setOfficeId(null);
  };

  const renderModal = () => {
    if (!officeId) return null;

    if (isSmsModalOpen) {
      return (
        <CianSmsModal
          isOpen={isSmsModalOpen}
          onClose={handleClose}
          onSmsSubmitted={handleSmsSubmitted}
        />
      );
    }

    if (isDraftModalOpen) {
      return (
        <CianDraftModal
          isOpen={isDraftModalOpen}
          onClose={handleClose}
          officeId={officeId}
        />
      );
    }

    return null;
  };

  return {
    CianModal: renderModal,
    openCianModal,
    onClose: handleClose,
    isOpen,
  };
}
